import { MobXProviderContext } from "mobx-react";
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { useAuthExperience } from "../../auth/hooks/useAuthExperience";
import Unauthorized from "../../../shared/pages/Unauthorized";
import { redirectToHomeForAuthMode } from "../../../utils/stringUtils";
import { BRAND_KEY_ONE_HUB_FOR_CARE } from "../../../constants/brandConstants";

export default function Workspaces() {
  const { authStore } = useContext(MobXProviderContext);
  const authExperience = useAuthExperience();
  const authMode = String(authStore.getAuthMode?.() || "legacy_cognito_role").trim();
  const fallbackRoleType = String(
    authStore.getUserRoleType?.()
    || authStore.currentUserContext?.activeContext?.roleType
    || "provider",
  ).trim();

  if (authExperience.brandKey === BRAND_KEY_ONE_HUB_FOR_CARE) {
    return <Navigate to={redirectToHomeForAuthMode(authMode || "multi_role_context", fallbackRoleType)} replace />;
  }

  if (authMode === "multi_role_context") {
    return <Navigate to={redirectToHomeForAuthMode(authMode, fallbackRoleType)} replace />;
  }

  return <Unauthorized />;
}
